<div class="packages-cashout-container">
    <div class="cashout-model-container">
        <div class="packages-cashout-header">
            <div class="feature-icons">
                <!-- <span class="theme-bingo-cash-out"></span>
                <span class="theme-bingo-badge"></span> -->
                <bg-feature-icon [feature]="gamefeatureData"></bg-feature-icon>
            </div>
            <span class="packages-cashout-title">{{ featureTitle }}</span
            ><i class="theme-ex" (click)="close()"></i>
        </div>
        <div class="packages-cashout-body">
            <p class="cashout-model-msg">{{ featureContent }}</p>
        </div>
    </div>
</div>
